import newSakatoplanReducer from "./reducers";

export default newSakatoplanReducer